<template>
  <sidebar-item-body class="pc-note__openedlist" name="opened">
    <opened-item v-for="item in items" :key="item.id" :data="item"/>
  </sidebar-item-body>
</template>

<script>
import { mapGetters } from 'vuex'
import OpenedItem from '@/components/note/sidebar/OpenedListItem.vue'
import SidebarItemBody from '@/components/note/sidebar/SidebarItemBody.vue'

export default {
  components: {
    OpenedItem,
    SidebarItemBody
  },
  computed: {
    ...mapGetters('workbench/opened', {
      items: 'items'
    })
  }
}
</script>
